import { useState, useRef } from "react";
// route
import { useNavigate } from "react-router";
// api services
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
// models
import {
  DocumentosGeneralesModel,
  initialValuesDocumentosGeneralesModel,
} from "../models/DocumentosModel/documentosGenerales.model";
import { saveFile } from "../utils/saveFile";
import apiDocumentosGenerales from "../api/Documentos/api-documentosGenerales";
import DocumentosService from "../api/Documentos/api-documentos";
import { openNotification } from "../utils/Notifactions";
import { useEncrypt } from "./useEncrypt";

export const useDocumentacionGeneral = () => {
  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  const [documento, setDocumento] = useState<DocumentosGeneralesModel>(
    initialValuesDocumentosGeneralesModel
  );
  const [documentos, setDocumentos] = useState<Array<DocumentosGeneralesModel>>(
    []
  );
  const [modalVisualizarDocumento, setModalVisualizarDocumento] =
    useState(false);
  const [documentoVisulizar, setDocumentoVisulizar] = useState("");
  const [modalEditarDocumento, setModalEditarDocumento] = useState(false);
  const [guardoArchivo, setGuardoArchivo] = useState(false);
  const [indexDocumento, setIndexDocumento] = useState(0);
  const [modaleliminar, setModaleliminar] = useState<boolean>(false);
  const [nombreDocumento, setNombreDocumento] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef<any>();
  const navigate = useNavigate();
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      let type = e.target.files[0].type;

      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }

      const data = await saveFile(e);
      if (
        type === "application/pdf" ||
        type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        type === "image/png" ||
        type === "image/jpeg"
      ) {
        setGuardoArchivo(true);
        return setDocumento({ ...documento, url_documento: data.data });
      }
    }
  };
  const agregarfila = () => {
    if (Array.isArray(documentos)) {
      setGuardoArchivo(false);
      setDocumentos([...documentos, documento]);
    } else {
      setDocumentos([documento]);
    }

    return setDocumento(initialValuesDocumentosGeneralesModel);
  };
  const eliminarFila = async (index: number) => {
    let infoupdate = [...documentos];
    setModaleliminar(false);
    if (infoupdate[index].url_documento) {
      await DocumentosService.eliminarArchivo(infoupdate[index].url_documento);
    }
    infoupdate = infoupdate.filter((data: any, i: number) => i !== index);
    infoupdate = infoupdate.map((data: any, i: number) => {
      return {
        ...data,
        index: i,
      };
    });
    return setDocumentos(infoupdate);
  };
  const guardarycontinuar = async () => {
    setLoading(true);
    await apiDocumentosGenerales.postDocumentosTecnicos(
      idConvocatoria,
      documentos
    );
    setLoading(false);
    navigate("/administrador/publicarConvocatoria");
  };
  const editarFila = () => {
    let infoupdate = [...documentos];
    infoupdate[indexDocumento] = documento;
    return setDocumentos(infoupdate);
  };
  const cargarDocumentosGenerales = async () => {
    let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
    if (data.documentos_generales === null) data.documentos_generales = [];
    return setDocumentos(data.documentos_generales);
  };
  return {
    documento,
    setDocumento,
    documentos,
    setDocumentos,
    fileInputRef,
    guardarArchivo,
    agregarfila,
    editarFila,
    eliminarFila,
    guardarycontinuar,
    modalvisualizardocumento: modalVisualizarDocumento,
    setModalVisualizarDocumento,
    documentovisualizar: documentoVisulizar,
    setDocumentoVisulizar,
    modaleditardocumento: modalEditarDocumento,
    setModalEditarDocumento,
    setIndexDocumento,
    indexdocumento: indexDocumento,
    cargarDocumentosGenerales,
    guardoArchivo,
    setGuardoArchivo,
    modaleliminar,
    setModaleliminar,
    nombreDocumento,
    setNombreDocumento,
    loading,
  };
};
